import type { ButtonHTMLAttributes, ReactNode } from 'react';
import './components.css';

type Variant = 'primary' | 'secondary' | 'destructive' | 'ghost';
type Size = 'sm' | 'md';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: Variant;
  size?: Size;
  icon?: ReactNode;
  iconRight?: ReactNode;
}

export function Button({
  variant = 'secondary',
  size = 'md',
  icon,
  iconRight,
  children,
  className = '',
  ...rest
}: ButtonProps) {
  return (
    <button
      type="button"
      className={`iris-btn iris-btn-${variant} iris-btn-${size} ${className}`}
      {...rest}
    >
      {icon && <span className="iris-btn-icon">{icon}</span>}
      {children && <span className="iris-btn-label">{children}</span>}
      {iconRight && <span className="iris-btn-icon">{iconRight}</span>}
    </button>
  );
}
